import { Routes, Route, useNavigate, Navigate } from 'react-router-dom'
import { AuthData } from '../../auth/AuthWrapper'
import { nav } from './navigation'
import { NotFound } from '../pages/NotFound'
import { ForgotPassword } from '../pages/ForgotPassword'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { ResetPassword } from '../pages/ResetPassword'
import { Login } from '../pages/Login'
import { LogoutComponent } from '../pages/LogoutComponent'

export const RenderRoutes = () => {
  const { user, login } = AuthData()
  const LOADING_ENABLE = useSelector(state => state?.loading)
  const navigate = useNavigate()

  useEffect(() => {
    // Check for existing auth data
    const checkAuth = async () => {
      const storeData = localStorage.getItem('userData')

      if (storeData) {
        try {
          const userData = JSON.parse(storeData)
          const timestamp = userData.timestamp || 0
          const now = new Date().getTime()
          const twentyFourHours = 24 * 60 * 60 * 1000

          // Check if auth data is still valid (less than 24 hours old)
          if (now - timestamp < twentyFourHours) {
            await login(userData?.userName, userData?.password)
          } else {
            // Auth data expired, clear and redirect to login
            localStorage.removeItem('userData')
            localStorage.removeItem('userToken')
            localStorage.removeItem('permissionId')
            if (window.location.pathname !== '/login') {
              navigate('/login')
            }
          }
        } catch (err) {
          console.error('Auth check error:', err)
          navigate('/login')
        }
      } else if (
        window.location.pathname !== '/login' &&
        window.location.pathname !== '/forgot-password' &&
        window.location.pathname !== '/reset-password'
      ) {
        navigate('/login')
      }
    }

    checkAuth()
  }, [])

  return (
    <>
      <Routes>
        {nav.map((r, i) => {
          if (r.isPrivate && user.isAuthenticated) {
            return <Route key={i} path={r.path} element={r.element} />
          } else if (!r.isPrivate) {
            return <Route key={i} path={r.path} element={r.element} />
          }
          return null
        })}
        <Route path='/' element={<Login />} />
        <Route path='/logout' element={<LogoutComponent />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/reset-password/:token' element={<ResetPassword />} />
        <Route path='*' element={<Navigate to="/login" replace />} />
      </Routes>
      {LOADING_ENABLE && (
        <div className='cover' id='coverDiv'>
          <div className='cover-content'>
            <div className='loader'></div>
          </div>
        </div>
      )}
    </>
  )
}
